// extracted by mini-css-extract-plugin
module.exports = {"scoreDisplay":"ScoreDisplay_scoreDisplay__2v7nK","overallContainer":"ScoreDisplay_overallContainer__1yIda","subheading":"ScoreDisplay_subheading__181D-"};